<template>
  <!-- =========== Navbar Start =========== -->
  <LandingNavbar> </LandingNavbar>
  <!-- =========== Navbar End =========== -->

  <!-- =========== Mobile Menu Start (Offcanvas) =========== -->
  <LandingMobileMenu> </LandingMobileMenu>
  <!-- =========== Mobile Menu End =========== -->

  <router-view> </router-view>

  <!-- =========== footer Section start =========== -->
  <LandingFooter> </LandingFooter>
  <!-- =========== footer Section end =========== -->

  <!-- =========== Back To Top Start =========== -->
  <button
    data-toggle="back-to-top"
    class="fixed text-sm rounded-full z-10 bottom-5 end-5 h-9 w-9 text-center bg-primary/20 text-primary flex justify-center items-center"
  >
    <i class="fa-solid fa-arrow-up text-base"></i>
  </button>
  <!-- =========== Back To Top End =========== -->
</template>
<script setup>
import { useSettingsStore } from "@/stores/settingStore";
import { onMounted } from "vue";
import LandingFooter from "@/components/LandingLayout/template-parts/LandingFooter.vue";
import LandingNavbar from "@/components/LandingLayout/template-parts/LandingNavbar.vue";
import LandingMobileMenu from "@/components/LandingLayout/template-parts/LandingMobileMenu.vue";

import { useMenuStore } from "@/stores/menuStore";

const settingsStore = useSettingsStore();
const menuStore = useMenuStore();

onMounted(() => {
  settingsStore.fetchSettings();
  menuStore.fetchNavbarMenuItems();
  menuStore.fetchFooterMenuGroups();
});
</script>
